import { MagnifyingGlassPlusIcon } from '@phosphor-icons/react'
import { CSSProperties } from 'react'

import { Icon } from '@/components/ui/icon'

import * as S from './zoomable-image.styled'

interface ZoomHintProps {
  size?: string
}

/** Hover scrim with a magnifier; reveals itself when its positioned parent is hovered or focused. */
export const ZoomHint = ({ size = '3.2rem' }: ZoomHintProps) => (
  <S.Hint aria-hidden style={{ '--zoom-hint-size': size } as CSSProperties}>
    <Icon icon={MagnifyingGlassPlusIcon} color="white" />
  </S.Hint>
)
